import { Injectable } from '@angular/core';


/*
  Generated class for the VariablesGlobales provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class VariablesGlobales {
    public static latitude: number;
    public static longitude: number;
    public urlServidor: string = "https://guiapueblo.es/";
    //public static urlServidor: string = "http://localhost/";
    public static urlServidor: string = "https://guiapueblo.es/";
    //Ficheros php para consultas
    public static consultaAsociaciones = "datosAsociaciones.php";
    public static consultaAsociacionesGenerales = "consultaAsociacionesGenerales.php";
    public static consultaAsociacion = "datosAsociacion.php";
    public static consultaCategoriasAso = "datosCategoriasAso.php";
    public static consultaActividades = "datosActividades.php";
    public static consultaListaCategorias = "datosListaCategorias.php";
    public static consultaCategoriasEmp = "datosCategoriasNew.php";
    public static consultaCategoriasNoti = "datosCategoriasNoti.php";
    public static consultaCiudadesProvincia = "datosCiudadesProvincia.php";
    public static consultaProvinciasComunidad = "datosProvinciasComunidad.php";
    public static consultaProvinciasComunidadCiudades = "datosProvinciasComunidadYCiudades.php";
    public static consultaComunidadesAutonomas = "datosComunidadesAutonomas.php";
    public static consultaCiudades = "datosCiudadesNew.php";
    public static consultaZonaEmpresas = "datosZonaEmpresas.php";
    public static consultaZonaCiudad = "datosZonaCiudad.php";
    public static consultaEmpresa = "datosEmpresaNew2.php";
    public static consultaEmpresas = "datosEmpresasNew2.php";
    public static consultaLugares = "datosLugares.php";
    public static consultaNoticias = "datosNoticias.php";
    public static consultaSubCategorias = "datosSubCategoriasNew2.php";
    public static consultaListaSubCategoria = "datosSubCategorias.php";
    public static consultaFiestas = "datosFiestas.php";
    public static consultaBusqueda = "datosBusquedaNew.php";
    public static consultaBusquedaParametrizada = "datosBusquedaParametrizada.php";
    public static consultaNoticiasFav = "consultaNoticiasFav.php";
    public static consultaFavoritos = "consultaFavoritos.php";
    public static consultaNoticiasGenerales = "consultaNoticiasGenerales.php";
    public static consultaCategoriasNotiGenerales = "consultaCategoriasNotiGenerales.php";
    public static consultaOcio = "datosOcio.php";
    public static consultaCategoriasOcio = "datosCategoriasOcio.php";

    //Ficheros php para insercion y borrado
    public static insertaFavoritoNoticia ="insertaFavoritoNoticia.php";
    public static insertaFavoritoAsociacion ="insertaFavoritoAsociacion.php";
    public static insertaFavoritoEmpresa ="insertaFavoritoEmpresa.php";
    public static insertaFavoritoOcio ="insertaFavoritoOcio.php";
    public static deleteFavoritoOcio ="deleteFavoritoOcio.php";
    public static deleteFavoritoNoticia ="deleteFavoritoNoticia.php";
    public static deleteFavoritoAsociacion ="deleteFavoritoAsociacion.php";
    public static deleteFavoritoEmpresa ="deleteFavoritoEmpresa.php";

    //Directorios de imagenes
    public static categoriasOfertas = "categoriaOcioImagenes/";
    public static ofertasImagenes = "ocioImagenes/";
    public static actividadImagenes = "actividadImagenes/";
    public static asociacionImagenes = "asociacionImagenes/";
    public static empresaImagenes = "empresaImgenes/";
    public static lugaresImagenes = "lugaresImagenes/";
    public static fiestasImagenes = "fiestasImagenes/";
    public static noticiasImagenes = "noticiasImagenes/";
    public static categoriasNoticiasImagenes = "categoriasNoticiasImagenes/";
    public static puebloImagen = "puebloImagen/";
    public static ciudadImagen = "ciudadImagenes/";
    public static empresasPdfs = "empresasPdfs/";
    public static lugaresPdfs = "lugaresPdfs/";
    public static fiestasPdfs = "fiestasPdfs/";
    public static categoriasAsociaciones="categoriaAsociacionImagenes/";


    //Contador de visitas empresa
    public static contadorVisitasEmpresa = "incrementarVisitasEmpresa.php";
  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/providers/variables-globales.ts